import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { usePipelineContext } from '@/context/pipelineContext';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { getDealClientId } from '@/features/deals/helper';
import { useGetRelationshipCompanyQuery } from '@/features/relationshipCompanies/relationshipCompaniesApi';

export const DataGridTaskObjectType = ({ row }) => {
	const { dealId, clientId } = row;

	const { data: dealData } = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	const resolvedClientId = clientId ?? getDealClientId(dealData);
	const { data: clientData } = useGetClientRowQuery(resolvedClientId, {
		skip: !resolvedClientId,
	});

	const { data: relationshipCompanyData } = useGetRelationshipCompanyQuery(
		row?.relationshipCompanyId,
		{ skip: !row?.relationshipCompanyId },
	);

	const pipelineId = dealData?.pipeline;
	const { pipeline } = usePipelineContext(pipelineId);

	const pipelineName = (() => {
		const p = pipeline?.label ?? '';
		return p && p.endsWith('s') && p.toUpperCase() !== 'NEW BUSINESS' ? p.slice(0, -1) : p;
	})();

	const displayName =
		pipelineName ||
		(clientData ? 'Client Task' : '') ||
		(relationshipCompanyData ? 'Relationship Task' : '');

	return <Typography variant='inherit'>{displayName ?? '-'}</Typography>;
};
